import { render, staticRenderFns } from "./Leaderboard.vue?vue&type=template&id=a5b1e840&scoped=true"
import script from "./Leaderboard.vue?vue&type=script&lang=js"
export * from "./Leaderboard.vue?vue&type=script&lang=js"
import style0 from "./Leaderboard.vue?vue&type=style&index=0&id=a5b1e840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b1e840",
  null
  
)

export default component.exports